import { render, staticRenderFns } from "./CreatorCommentsDrawer.vue?vue&type=template&id=45d657b4&scoped=true&"
import script from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js&"
export * from "./CreatorCommentsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreatorCommentsDrawer.vue?vue&type=style&index=0&id=45d657b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d657b4",
  null
  
)

export default component.exports